import { PureComponent, createRef } from 'react';
import { fontFamily } from '../Consts';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    SubTitle,
} from 'chart.js';

import { Bar } from 'react-chartjs-2'

import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    SubTitle,
    annotationPlugin,
);

export class BarChartStacked extends PureComponent {
    myBarChartRef = createRef(null);

    componentDidMount() {
        // noop
    }

    getKritBColors = (dc, dcw, c, idx, cp) => {
        let colors = [...dc];
        let af = 1;
        if (af > 0) {
            colors[idx] = c;
        }
        return colors;
    }

    render() {
        let colorvars = [];
        let i = -1;
        do {
            i++;
            let colorvar = getComputedStyle(document.documentElement).getPropertyValue(
                `--color-wheel-${i + 1}`,
            );
            if (colorvar.length) colorvars.push(colorvar);
        } while (typeof colorvars[i] !== 'undefined');

        const dF = this.props.evalData;

        const columnColorStd = colorvars[4];
        // const columnColorAtt = colorvars[0];

        // const barColorKritB = colorvars[1];
        // should be variable, won't work... :/
        const barColorKritB = "rgba(127, 128, 134,1 )";

        let labels = [];
        let dataPoints = [];
        let dataColors = [];

        labels = ['0-9%', '10-19%', '20-29%', '30-39%', '40-49%', '50-59%', '60-69%', '70-79%', '80-89%', '90-100%'];
        dataPoints = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        for (let i = 0; i < dataPoints.length; i++) {
            dataColors[i] = columnColorStd;
        }

        let dataColorsWorker = [...dataColors];

        let numPupils = dF[0].numPupils;
        let numTasks = dF[0].numTasks;
        let maxPoints = dF[0].maxPoints;
        let theGrid = dF[1].grid;

        for (let i = 0; i < numPupils; i++) {
            let pigeonSlot = Math.trunc((Number(theGrid[i][numTasks + 2].value) / maxPoints) * 10);
            if(pigeonSlot === 10) {
                pigeonSlot = 9;
            }
            dataPoints[pigeonSlot] += 1;
        }

        let maxYAxis = Math.max(...dataPoints) + 1;

        const data = {
            labels,
            datasets: [
                {
                    label: dF[1].klasse + ' in [' + dF[1].fach + ']',
                    data: dataPoints,
                    backgroundColor: (barElement) => {
                        if (barElement.active === true) {
                            let colors = this.getKritBColors(
                                dataColors,
                                dataColorsWorker,
                                barColorKritB,
                                barElement.index,
                                this.props.evalData[0].crossProducts[barElement.index]
                            );
                            return colors;
                        }
                        else {
                            return dataColorsWorker;
                        }
                    },
                    hoverOffset: 4,
                },
            ],
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            elements: {
                bar: {
                    inflateAmount: 0,
                },
            },
            scales: {
                x: {
                    ticks: {
                        font: {
                            family: fontFamily,
                            size: 14,
                        },
                    },
                },
                y: {
                    min: 0,
                    max: maxYAxis,
                    ticks: {
                        stepSize: 1,
                        font: {
                            family: fontFamily,
                            size: 14,
                        },
                    },
                },
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        title: (ctx) => {
                            return "Lösungsgrad " + ctx[0].label + " - " + ctx[0].raw + " SuS";
                        },
                        label: (ctx) => {
                            return ctx.dataset.label;
                        },
                    },
                },
                legend: {
                    position: 'top',
                    onClick: (evt, legendItem, legend) => {
                        const datasets = legend.legendItems.map((dataset, index) => {
                            return dataset.text;
                        })
                        const idx = datasets.indexOf(legendItem.text);
                        legend.chart.isDatasetVisible(idx) ? legend.chart.hide(idx) : legend.chart.show(idx);
                    },
                    labels: {
                        generateLabels: (chart) => {
                            let vis = [];
                            for (let i = 0; i < chart.data.datasets.length; i++) {
                                if (chart.isDatasetVisible(i) === false) {
                                    vis.push(true);
                                }
                                else {
                                    vis.push(false);
                                }
                            }

                            return chart.data.datasets.map(
                                (dataset, index) => ({
                                    text: dataset.label,
                                    fillStyle: columnColorStd,
                                    strokeStyle: columnColorStd,
                                    hidden: vis[index],
                                })
                            )
                        },
                        boxWidth: 20,

                    }
                },
                title: {
                    display: true,
                    text: "Verteilung der Lösungsgrade [" + numPupils + ' SuS]',
                    color: 'grey',
                    font: {
                        size: 20,
                        family: fontFamily,
                        weight: 'normal',
                    },
                },
                annotation: {
                    annotations: {
                        labelNorm: {
                            type: 'label',
                            xValue: -0.37,
                            yValue: maxYAxis / 2,
                            backgroundColor: 'transparent',
                            content: ['Anzahl SuS'],
                            rotation: -90,
                            textAlign: 'left',
                            color: 'black',
                            font: {
                                size: 12,
                                family: fontFamily,
                            }
                        },
                    },
                },
            },
        };

        return (
            <>
                <div className="barSizer">
                    <Bar options={options}
                        data={data}
                        ref={this.myBarChartRef}
                    />
                </div>
            </>
        )
    }
}

export default BarChartStacked;
